module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "paokfc.0367cc57.jpg";